<adapt-feature-guidance [configItem]="configItem">
    <p>{{ oauthService.getPromptText(personalConfig) }}</p>

    @if (calendarProvider) {
        @if (personalConfig) {
            @if (hasConfigureAccess) {
                <p>
                    If you would like to change the configured calendar integration for your entire organisation, please use the
                    organisation configuration area:
                    <a [routerLink]="organisationConfigRoute?.path"
                       [queryParams]="{
                            section: ConfigArea[ConfigArea.CalendarIntegration],
                        }">Organisation calendar integration</a>
                </p>
            } @else {
                <p>
                    If you would like to change the configured calendar integration, please contact your
                    {{ projectLabel }} administrator.
                </p>
            }
        } @else {
            @if (!calendarProvider.isLocal) {
                <p>
                    If you would like to logout or switch your provider account, please use the personal configuration area:
                    <a [routerLink]="personalConfigRoute?.path"
                       [queryParams]="{
                            section: ConfigArea[ConfigArea.CalendarIntegration],
                        }">Personal calendar integration</a>
                </p>
            }
        }
    }
</adapt-feature-guidance>

@if (!calendarProvider && hasConfigureAccess) {
    <div class="alert alert-warning">
        <strong>No calendar integration has been configured.</strong>
        Please select one of the options below to set the calendar integration for the organisation.
    </div>
}

@if ((!calendarProvider || personalConfig) && !integrationIsDisabled) {
    <adapt-calendar-provider-select [horizontal]="false"
                                    [showLogoutButton]="true"
                                    [showDisableIntegration]="!personalConfig || (hasConfigureAccess && !calendarProvider)"></adapt-calendar-provider-select>
} @else {
    @if (integrationIsDisabled) {
        <p>Calendar integration is not currently enabled for your organisation.</p>
    } @else {
        <p>
            Your organisation is configured to use
            <strong>{{ providerText }}</strong> as the calendar integration provider.
        </p>
    }
    @if (!personalConfig && hasConfigureAccess) {
        <div class="mt-2">
            <button type="button"
                    role="button"
                    class="btn btn-primary"
                    [adaptBlockingClick]="resetIntegration">{{ integrationIsDisabled ? "Enable" : "Reset" }} calendar integration</button>
        </div>
    }
}

@if (personalConfig && (!calendarProvider || !integrationIsDisabled) && !calendarProvider?.isLocal && (oauthService.isAuthenticated$ | async) === false) {
    <div class="d-flex flex-column pt-3">
        <dx-check-box text="Hide calendar integration on meetings page"
                      [value]="meetingCalendarIntegrationDismissed"
                      (valueChange)="onMeetingCalendarIntegrationDismissedChange($event)"></dx-check-box>
    </div>
}
